import { createFileRoute } from "@tanstack/react-router";

import { BlogListing } from "@/components/blog/BlogListing";
import { JsonLd } from "@/components/seo/JsonLd";
import { carregarPaginaBlog } from "@/lib/blog-page";
import { breadcrumbSchema } from "@/lib/schema";

export const Route = createFileRoute("/blog/")({
  loader: () => carregarPaginaBlog({ pagina: 1, path: "/blog/" }),
  head: ({ loaderData }) => ({ meta: loaderData?.meta ?? [] }),
  component: Pagina,
});

function Pagina() {
  const { dados, h1, subtitulo, trilha } = Route.useLoaderData();
  return (
    <>
      <BlogListing dados={dados} h1={h1} subtitulo={subtitulo} trilha={trilha} />
      <JsonLd data={breadcrumbSchema(trilha.filter((item) => item.nome !== "Conteúdos"))} />
    </>
  );
}
